import {NativeModules, Platform, StatusBar} from "react-native";

// 安全地解构 NativeModules，避免在 Web 平台上访问未初始化的变量
// 使用可选链和默认值，确保在模块未初始化时不会报错

export const STATUSBAR_HEIGHT = 0;

export type SystemBarType = "immerse_all" | "immerse_state" | "immerse_navigation";

export function ChangeSystemBar(type: SystemBarType, isLightState: boolean, isLightNav: boolean) {
    
}


export function ImmerseStatus() {
   
}

export function ImmerseNavigation() {
   
}

export function Immerse() {
   
}

export function ImmerseDark() {
    
}

export function RemoveImmerse() {
   
}

export const isIos = Platform.OS === "ios";
export const isAndroid = Platform.OS === "android";

export const updateIosLaunage = (lng: string) => {
    if (isIos) {
        let l = lng
        if (lng === 'zh') {
            l = "zh-Hans"
        }
    }
}
